import type { PublicConfig } from "../lib/api";

export type SiteBenefit = {
  id: "payments" | "protection" | "shipping" | "photography";
  label: string;
  comingSoon: boolean;
};

export const BENEFIT_DISPLAY_MS = 5200;
export const BENEFIT_FADE_MS = 380;

export function nextBenefitIndex(current: number, count: number, direction: 1 | -1 = 1) {
  return count > 0 ? (current + direction + count) % count : 0;
}

export function shouldRotateBenefits(state: { manuallyStopped: boolean; hovered: boolean; focused: boolean; visible: boolean; reducedMotion: boolean }) {
  return state.visible && !state.manuallyStopped && !state.hovered && !state.focused && !state.reducedMotion;
}

export function siteBenefits(config: PublicConfig | null): SiteBenefit[] {
  const capabilities = config?.capabilities;
  const services = capabilities && typeof capabilities === "object" && !Array.isArray(capabilities)
    ? capabilities as Record<string, unknown> : {};
  // Only an explicitly enabled checkout may advertise its transaction services.
  const ready = config?.configured === true && config.checkoutEnabled === true
    && config.paymentsConfigured === true && config.shippingConfigured === true
    && services.checkout === true && services.payments === true && services.shipping === true;
  return [
    { id: "photography", label: "Solo fotografia e astronomia", comingSoon: false },
    { id: "payments", label: "Pagamenti senza uscire dal sito", comingSoon: !ready },
    { id: "protection", label: "Protezione per i tuoi acquisti", comingSoon: !ready },
    { id: "shipping", label: "Spedizioni con tracciamento", comingSoon: !ready },
  ];
}
